import { Product } from '../types/Product';

export const products: Product[] = [
  {
    id: '1',
    name: 'Lot de textile écologique 100% coton',
    category: 'Textile',
    price: 5000,
    currency: 'EUR',
    origin: 'France',
    destination: ['Espagne', 'Allemagne', 'Italie'],
    description: 'Lot de 1000 t-shirts écologiques en coton bio certifié, disponibles en plusieurs tailles et coloris. Parfait pour les revendeurs de mode éthique.',
    moq: 500,
    stock: 10000,
    rating: 4.8,
    reviewCount: 127,
    image: 'https://images.unsplash.com/photo-1620799140408-edc6dcb6d633?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's1',
      name: 'EcoTextile France',
      rating: 4.9,
      verifiedSince: '2018-05-12',
      country: 'France'
    }
  },
  {
    id: '2',
    name: 'Composants électroniques - Circuits imprimés',
    category: 'Électronique',
    price: 12500,
    currency: 'EUR',
    origin: 'Allemagne',
    destination: ['France', 'Suisse', 'Belgique'],
    description: 'Lot de 5000 circuits imprimés de haute qualité pour applications industrielles. Testés selon les normes européennes les plus strictes.',
    moq: 1000,
    stock: 8000,
    rating: 4.6,
    reviewCount: 89,
    image: 'https://images.unsplash.com/photo-1597848212624-a19eb35e2651?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's2',
      name: 'TechCircuits GmbH',
      rating: 4.7,
      verifiedSince: '2016-11-03',
      country: 'Allemagne'
    }
  },
  {
    id: '3',
    name: 'Cosmétiques bio en vrac',
    category: 'Cosmétique',
    price: 8750,
    currency: 'EUR',
    origin: 'Italie',
    destination: ['France', 'Espagne', 'Portugal'],
    description: 'Collection de produits cosmétiques biologiques en vrac : crèmes, huiles et lotions. Formules naturelles, sans parabènes ni conservateurs.',
    moq: 200,
    stock: 5000,
    rating: 4.9,
    reviewCount: 213,
    image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's3',
      name: 'NaturaCosmetica',
      rating: 4.8,
      verifiedSince: '2019-02-18',
      country: 'Italie'
    }
  },
  {
    id: '4',
    name: 'Matériaux de construction écologiques',
    category: 'Construction',
    price: 18900,
    currency: 'EUR',
    origin: 'Suède',
    destination: ['France', 'Allemagne', 'Pays-Bas'],
    description: 'Panneaux isolants écologiques à base de fibres de bois recyclé. Excellente performance thermique et phonique pour constructions durables.',
    moq: 100,
    stock: 3000,
    rating: 4.7,
    reviewCount: 65,
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's4',
      name: 'EcoConstruct AB',
      rating: 4.6,
      verifiedSince: '2017-09-25',
      country: 'Suède'
    }
  },
  {
    id: '5',
    name: 'Fournitures de bureau recyclées',
    category: 'Papeterie',
    price: 3750,
    currency: 'EUR',
    origin: 'Pays-Bas',
    destination: ['Belgique', 'France', 'Allemagne'],
    description: 'Assortiment complet de fournitures de bureau fabriquées à partir de matériaux recyclés : papier, stylos, classeurs et accessoires.',
    moq: 500,
    stock: 12000,
    rating: 4.5,
    reviewCount: 108,
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's5',
      name: 'GreenOffice BV',
      rating: 4.4,
      verifiedSince: '2020-01-10',
      country: 'Pays-Bas'
    }
  },
  {
    id: '6',
    name: 'Équipements agroalimentaires professionnels',
    category: 'Agroalimentaire',
    price: 25000,
    currency: 'EUR',
    origin: 'France',
    destination: ['Espagne', 'Italie', 'Maroc'],
    description: 'Machines et équipements de traitement agroalimentaire de pointe. Conformes aux normes HACCP et certifiés pour l\'exportation internationale.',
    moq: 5,
    stock: 120,
    rating: 4.9,
    reviewCount: 47,
    image: 'https://images.unsplash.com/photo-1581092921461-39b9d007dfb9?ixlib=rb-1.2.1&auto=format&fit=crop&w=800&q=80',
    seller: {
      id: 's6',
      name: 'AgriTech Solutions',
      rating: 4.9,
      verifiedSince: '2015-03-07',
      country: 'France'
    }
  }
];
